import { FormEvent, useMemo, useState } from 'react';

interface ModalJustificativaVotoProps {
  etapaLabel: string;
  selecionadoPor: string;
  timestamp: Date;
  onCancel: () => void;
  onConfirm: (justificativa: string) => void;
}

export function ModalJustificativaVoto({
  etapaLabel,
  selecionadoPor,
  timestamp,
  onCancel,
  onConfirm
}: ModalJustificativaVotoProps) {
  const [justificativa, setJustificativa] = useState('');

  const timestampLabel = useMemo(() => {
    return timestamp.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
  }, [timestamp]);

  const justificativaLimpa = justificativa.trim();
  const canSubmit = justificativaLimpa.length > 0;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!canSubmit) {
      return;
    }

    onConfirm(justificativaLimpa);
  };

  return (
    <div className="bg-white rounded-lg overflow-hidden w-full max-w-[620px]">
      <div className="p-4 md:p-5 border-b border-gray-bb-5">
        <h2 className="text-blue-bb-1 text-[26px] md:text-[30px] font-title font-bold leading-tight">
          Justificativa do envio
        </h2>
        <p className="text-[#2C323F] text-sm md:text-base mt-2">
          Antes de enviar sua seleção, informe a justificativa desta etapa.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="content px-4 md:px-5 py-4 border-b border-gray-bb-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
            <div className="border border-[#E0E7FF] rounded-md p-3 bg-[#F8FAFF]">
              <span className="block text-[11px] uppercase tracking-wide text-[#6B7280] font-semibold">Selecionado por</span>
              <span className="block text-sm text-[#111214] font-medium mt-1">{selecionadoPor}</span>
            </div>
            <div className="border border-[#E0E7FF] rounded-md p-3 bg-[#F8FAFF]">
              <span className="block text-[11px] uppercase tracking-wide text-[#6B7280] font-semibold">Data e hora</span>
              <span className="block text-sm text-[#111214] font-medium mt-1">{timestampLabel}</span>
            </div>
          </div>

          <div className="border border-[#E0E7FF] rounded-md p-3 bg-[#F8FAFF] mb-4">
            <span className="block text-[11px] uppercase tracking-wide text-[#6B7280] font-semibold">Etapa</span>
            <span className="block text-sm text-[#111214] font-medium mt-1">{etapaLabel}</span>
          </div>

          <label htmlFor="justificativa-envio" className="block text-sm text-[#2C323F] font-semibold mb-2">
            Justificativa
          </label>
          <textarea
            id="justificativa-envio"
            value={justificativa}
            onChange={(event) => setJustificativa(event.target.value)}
            rows={4}
            className="w-full border border-[#CCD8FF] rounded-md px-3 py-2 text-sm text-[#111214] focus:outline-none focus:ring-2 focus:ring-blue-bb-1 focus:border-blue-bb-1 resize-none"
            placeholder="Descreva a justificativa da sua seleção"
            required
          />
        </div>

        <div className="flex justify-end gap-2 p-4 md:p-5 actions">
          <button
            type="button"
            onClick={onCancel}
            className="bg-[#E0E9FF] text-blue-bb-1 rounded-[4px] px-4 py-2 text-sm font-title font-bold uppercase"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={!canSubmit}
            className="bg-yellow-bb text-blue-bb-1 rounded-[4px] px-4 py-2 text-sm font-title font-bold uppercase disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Confirmar envio
          </button>
        </div>
      </form>
    </div>
  );
}
